import { useContext, useMemo, memo } from 'react';
import { useWatch } from 'react-hook-form';

import { GuidelineRuleDtoEnums } from 'api/repositories/guidelineRules/guidelineRules.types';
import Checkbox from 'components/checkbox';
import GUIDELINE_RULES from 'constants/guidelineRules';
import CampaignFormField from '../../../../../../campaignFormFieldGroup/components/campaignFormField/campaignFormField';
import { CampaignFormStepTwoContext } from '../../../../../campaignFormStepTwo.context';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import { GuidelineRuleFormField } from 'pages/campaigns/campaignForm/campaignForm.types';

interface TagCheckboxFieldProps {
  label: string;
  groupName: GuidelineRuleDtoEnums['GROUP_NAME'];
}

const TagCheckboxField = ({ groupName, label }: TagCheckboxFieldProps) => {
  const { guidelineRuleFormMethods } = useContext(CampaignFormContext);
  const { baseGuidelineRules } = useContext(CampaignFormStepTwoContext);

  const fieldValue = useWatch({
    control: guidelineRuleFormMethods.control,
    name: groupName,
  }) as GuidelineRuleFormField;

  const baseRules = useMemo(() => {
    return baseGuidelineRules?.filter((rule) => rule.groupName === groupName);
  }, [baseGuidelineRules, groupName]);

  const onChangeValue = (value: any) => {
    guidelineRuleFormMethods.setValue(groupName, {
      ...fieldValue,
      value: fieldValue?.value === value ? null : value,
    });
  };

  return (
    <CampaignFormField label={label}>
      {baseRules?.map((rule, index) => (
        <Checkbox
          key={`${groupName}-${index}`}
          text={GUIDELINE_RULES.GetOptionTranslationMap(
            groupName,
            rule.value as any,
          )}
          checked={fieldValue?.value === rule.value}
          onClick={() => onChangeValue(rule.value)}
        />
      ))}
    </CampaignFormField>
  );
};

export default memo(TagCheckboxField);
